module.exports = __webpack_public_path__ + "img/bez_hypoteky_v1.078dc452.svg";